var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videojs",staticClass:"video-js",attrs:{"poster":_vm.poster,"muted":"","controls":"","preload":"auto","autoplay":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.stream,"type":"application/x-mpegURL"}})])}
var staticRenderFns = []

export { render, staticRenderFns }